import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";
import { getDeviceFingerprint } from "../../utils/fingerprint";

const submitReservation = async (
    reservationHead,
    items,
    addonItems,
    event,
    type,
    isPwf,
    token,
    preRegister,
    voucherCode = null,
) => {
    const deviceFingerprint = await getDeviceFingerprint();
    const body = {
        reservationHead,
        event,
        items,
        addonItems,
        type,
        isPwf,
        cart_token: token,
        preRegister: preRegister || null,
        device_fingerprint: deviceFingerprint,
    };
    if (voucherCode) {
        body.voucher_code = voucherCode;
    }
    const response = await axios.post(
        routes.submitReservation,
        body,
        AXIOS_DEFAULT_CONFIG
    );
    return response;
};
export default submitReservation;